import { Link } from 'react-router-dom';
import LegalLayout from '@/components/LegalLayout';
import { BUSINESS } from '@/lib/legal';

const FAQ = [
  {
    q: 'How do I pay, and when does my plan start?',
    a: 'You can pay online by card (processed securely by Square) or in store. Online plans activate once payment is confirmed; in-store plans activate once our staff confirm your payment. Until then your plan shows as pending.',
  },
  {
    q: 'I forgot my password — how do I reset it?',
    a: 'On the login screen choose "Forgot password". If you have trouble, visit us or contact support and our staff can issue you a secure 4-digit reset code to set a new password.',
  },
  {
    q: 'How does pickup work?',
    a: 'Open the app (or your account), show your personal QR code at the counter, and we deduct one tiffin credit. Your remaining balance updates instantly.',
  },
  {
    q: 'How do I get a refund?',
    a: 'See our Refund & Cancellation Policy. In short: unused credits may be refundable within 14 days of purchase — email us with your Customer ID and payment details.',
  },
  {
    q: 'How do I delete my account?',
    a: 'In the app or website, go to Profile and tap "Delete My Account", or see the Delete My Account page. Deletion removes your personal information permanently.',
  },
];

export default function Support() {
  return (
    <LegalLayout
      title="Support & Contact"
      updated={false}
      intro="We're here to help. Reach us using the details below, or check the FAQ."
    >
      <h2>Contact us</h2>
      <ul>
        <li><strong>Business:</strong> {BUSINESS.legalName}</li>
        <li><strong>Support email:</strong> <a href={`mailto:${BUSINESS.supportEmail}`}>{BUSINESS.supportEmail}</a></li>
        <li><strong>Phone:</strong> <a href={`tel:${BUSINESS.phone}`}>{BUSINESS.phone}</a></li>
        <li><strong>Address:</strong> {BUSINESS.address}</li>
        <li><strong>Hours:</strong> {BUSINESS.hours}</li>
      </ul>

      <h2>Payment help</h2>
      <p>
        Payments are handled by Square. If a charge failed, was duplicated, or you need a refund, email us with the
        date and amount — see the <Link to="/refunds">Refund &amp; Cancellation Policy</Link>.
      </p>

      <h2>Login &amp; password help</h2>
      <p>
        Use "Forgot password" on the login screen, or contact us for a staff-issued reset code. Never share your
        password with anyone.
      </p>

      <h2>Account deletion</h2>
      <p>
        You can delete your account and personal data at any time — see{' '}
        <Link to="/delete-account">Delete My Account</Link>.
      </p>

      <h2>Frequently asked questions</h2>
      {FAQ.map((f) => (
        <div key={f.q}>
          <h3>{f.q}</h3>
          <p>{f.a}</p>
        </div>
      ))}
    </LegalLayout>
  );
}
